import { Injectable } from '@angular/core';
import { OrganisationTypeEnum } from '../enums/organisation-types';

@Injectable({
  providedIn: 'root',
})
export class SaasService {
  public static readonly ENGYNN_LOGO_URL =
    'https://s3.eu-west-2.amazonaws.com/bucket.engineius.portal-static-content/engynn/engynn_full.svg';

  constructor() {}

  /*
    True when the app is being served from the Engynn (SaaS) host rather than the
    Engineius portal host. Used for branding on pages shown before we know who the
    user is (login, MFA, password reset/setup).
   */
  public get isSaasHost(): boolean {
    return window.location.hostname.toLowerCase().includes('engynn');
  }

  /*
    1. If user is a SaaS user, redirect to the SaaS portal, return true.
    2. If user is a customer, do nothing, return false.
   */
  public redirectToSaasIfSaasUser(userOrgType: OrganisationTypeEnum): boolean {
    if (userOrgType == OrganisationTypeEnum.SaaSCustomer) {
      // have to use window.location.href instead of router, because it is not part of this ClientApp, but part of the SaasClientApp
      window.location.href = '/v3/my-orders';
      return true;
    }
    return false;
  }
}
